import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { webApi } from '@mi-front/api-clients';
import { useSocialExportEnabledForStation } from './useSocialExportEnabledForStation';

/**
 * Returns whether social export is enabled for the station and the given platform is connected.
 * Uses the BFF connections-for-station query (single request for all platforms) and picks the platform.
 */
export function useSocialExportConnectedForStation(stationId: string, platform: SocialPlatform) {
  const enabled = useSocialExportEnabledForStation(stationId, platform);
  const connectionsQuery = webApi.useGetSocialConnectionsConnectionsForStation(stationId, {
    query: {
      select: (data) =>
        data?.results?.find((item) => item.platform === platform.id)?.connected ?? false,
    },
  });

  return enabled && !!connectionsQuery.data;
}
